// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
// Use REACT_APP_BACKEND_URL for preview; fall back to same-origin for production deployments
const envUrl = process.env.REACT_APP_BACKEND_URL || "";

let resolvedUrl = "";
try {
  if (envUrl && envUrl !== window.location.origin) {
    const envHost = new URL(envUrl).hostname;
    const currentHost = window.location.hostname;
    if (envHost === currentHost || currentHost.includes("preview.emergentagent.com")) {
      resolvedUrl = envUrl;
    }
  }
} catch {
  resolvedUrl = "";
}

export const BACKEND_URL = resolvedUrl;
export const API = `${resolvedUrl}/api`;
